import { useSelector } from 'react-redux';
import { useShipFromValidation } from '../../../../../ship-from/components/ship-from-dropdown/validator';
import { mapStateToProps } from './container';

export const ShipFromValidator = ({ children, selectedShipFromId, selectedLabelProviderId }) => {
  const { shipFroms } = useSelector((state) => mapStateToProps(state, { selectedShipFromId }));
  const validation = useShipFromValidation({
    selectedShipFromId,
    shipFroms,
    selectedLabelProviderId,
  });

  return children({ validation });
};
